import { IIdAndNamePair } from '../../../../../models/Common';
import { IFormattedAccount } from 'models/Account';
import { AccountFormData } from '../types';
import { SERVER_DEFAULT_VALUES } from '../constant';
import moment from 'moment';

export const getYearFromDate = () => moment().add(1, 'year').format('YYYY-MM-DD');

export const transformFormDataForCreate = (formData: AccountFormData, productList: IIdAndNamePair[] = []) => {
    const { productId, mediaSpendTierId, bundlePlan, city, csmAuth0Id, seAuth0Id, domain, zipCode } = SERVER_DEFAULT_VALUES;
    return {
        productId,
        mediaSpendTierId,
        bundlePlan,
        city,
        csmAuth0Id,
        seAuth0Id,
        zipCode,
        endDate: getYearFromDate(),
        accountType: formData.accountType,
        regionId: parseInt(formData.region),
        salesforceId: formData.salesforceAccount,
        dataLocationId: parseInt(formData.dataLocation),
        defendDataTypes: formData.defendDataType,
        products: formData.activeLicenses.map((productId) => ({
            value: productId,
            label: productList.find((p) => p.id === productId)?.name || `Product ${productId}`,
        })),
        name: formData.accountName,
        email: formData.accountEmail,
        domain: formData.accountDomain || domain,
    };
};

export const transformFormDataForUpdate = (formData: AccountFormData, currentAccount: IFormattedAccount, productList: IIdAndNamePair[]) => {
    const {
        bundlePlan,
        mediaSpendTierId,
        isAgency,
        id,
        isBlockingControlGroup,
        zipCode,
        createdDate,
        logoUrl,
        phone,
        billingAddress,
        city,
        country,
        networkId,
        orgId,
        dataLocationId,
        productId,
        networks,
    } = currentAccount;
    const { activeLicenses, accountName, accountType, region, accountEmail, accountDomain, cheqAccountStatus, salesforceAccount, defendDataType } = formData;

    return {
        id,
        name: accountName,
        accountType: accountType,
        regionId: parseInt(region),
        dataLocationId,
        isAgency: !!isAgency,
        isBlockingControlGroup: isBlockingControlGroup || SERVER_DEFAULT_VALUES.isBlockingControlGroup,
        productId: productId || SERVER_DEFAULT_VALUES.productId,
        products: activeLicenses.map((productId) => ({
            value: productId,
            label: productList.find((p) => p.id === productId)?.name,
        })),
        createdDate,
        endDate: getYearFromDate(),
        csmAuth0Id: SERVER_DEFAULT_VALUES.csmAuth0Id,
        seAuth0Id: SERVER_DEFAULT_VALUES.seAuth0Id,
        bundlePlan: bundlePlan || SERVER_DEFAULT_VALUES.bundlePlanFallback,
        email: accountEmail,
        domain: accountDomain || SERVER_DEFAULT_VALUES.domain,
        logoUrl: logoUrl || SERVER_DEFAULT_VALUES.logoUrl,
        active: cheqAccountStatus,
        phone: phone || SERVER_DEFAULT_VALUES.phone,
        billingAddress: billingAddress || SERVER_DEFAULT_VALUES.billingAddress,
        country: country || SERVER_DEFAULT_VALUES.country,
        city: city || SERVER_DEFAULT_VALUES.city,
        zipCode: zipCode || SERVER_DEFAULT_VALUES.zipCode,
        mediaSpendTierId: mediaSpendTierId || SERVER_DEFAULT_VALUES.mediaSpendTierFallback,
        networkId: networkId || networks?.[0]?.id,
        salesforceId: salesforceAccount,
        orgId: orgId || SERVER_DEFAULT_VALUES.orgId,
        internalAdmin: (currentAccount as IFormattedAccount & { internalAdmin?: Record<string, unknown> }).internalAdmin || {},

        // Defend data types (if CHEQ Defend is selected)
        defendDataTypes: defendDataType,

        // Update flag - true if licenses changed
        updateProducts: activeLicenses.length !== currentAccount.products?.length || currentAccount.products?.some((p) => !activeLicenses.includes(p.value)),
    };
};
